import { Chip, Tooltip, Zoom } from '@mui/material'
import React from 'react'

interface ComponentArgs {
  // majorVersion: number
  // minorVersion: number
  version: string
}

const COATemplateVersionChip: React.FC<ComponentArgs> = (args: ComponentArgs) => {
  const variant: 'outlined' | undefined = 'outlined'
  const color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined = 'success'

  // if (args.majorVersion === 1) {
  //   color = 'warning'
  //   variant = 'outlined'
  // } else if (args.majorVersion === 2) {
  //   color = 'warning'
  //   variant = 'outlined'
  // } else if (args.majorVersion === 3) {
  //   color = 'warning'
  //   variant = 'outlined'
  // } else if (args.majorVersion === 4) {
  //   color = 'success'
  //   variant = 'outlined'
  // } else if (args.majorVersion === 5) {
  //   color = 'success'
  //   variant = 'outlined'
  // }

  return (
  <Tooltip title={`CellOwnerAgreementTemplateVersion: ${args.version}`} TransitionComponent={Zoom} arrow placement='bottom'>
    <Chip label={`${args.version}`} variant={variant} color={color} />
  </Tooltip>
  )
}

export default COATemplateVersionChip
